(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7171],{

/***/ 5661:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/seo-design-portfolio/affordable-seo-london",
      function () {
        return __webpack_require__(7706);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(362);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9472);
/* harmony import */ var components_common_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2034);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4870);
/* harmony import */ var components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4153);
/* harmony import */ var components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9266);








var details = {
    pageName: "Smooth Mover Removals",
    categories: "seo, ppc",
    description: "Smooth Mover Removals is a local business that provides removal services. We were asked to design and develop a new website for them. We also conducted an SEO audit, which we passed on to Smooth Mover so they could make the easily explained changes themselves.",
    parentDirectories: "seo-design-portfolio"
};
var Portfolio = data_keywords__WEBPACK_IMPORTED_MODULE_5__.LocalSEOArrays[7].keywords;
var contentRowClass = "row gx-0";
var titleClass = "display-6 mb-4";
var ProjectDetails = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        title: "".concat(Portfolio[0].title, " - ").concat(details.pageName),
                        description: details.description,
                        tag: details.categories,
                        urlPT: "",
                        urlENPT: "",
                        url: "".concat(Portfolio[0].url, "/").concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-")),
                        image: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "overflow-hidden position-relative blue",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-min-100vh h-md-auto color w-100"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "container gx-0 text-center mt-n10 wrapper image-wrapper bg-image bg-overlay text-white overflow-hidden h-min-100vh h-md-auto d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "h-100 w-100 hero-portfolio position-absolute left-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "w-100 object-fit-cover h-min-100vh h-md-auto w-min-100",
                                                src: "/img/clients/".concat(Portfolio[1].title.toLowerCase().replace(/ /g, "-"), "-bg.jpg"),
                                                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                                                alt: "".concat(Portfolio[1].title)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row mx-auto",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-md-12 mx-auto text-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "post-header mx-auto text-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                        className: "fs-15 text-uppercase text-white mb-3",
                                                        children: [
                                                            "- ",
                                                            Portfolio[0].title,
                                                            " -"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "display-4 text-capitalize",
                                                        children: details.pageName
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "wrapper bg-light wrapper-border",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-lg-12 offset-lg-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: titleClass,
                                                children: Portfolio[0].title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "overflow-hidden ".concat(contentRowClass),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-md-9 text-justify order-0 pe-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                className: "display-6 mb-4",
                                                                children: details.pageName
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                    className: "caption",
                                                                    children: details.description
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                children: [
                                                                    "SEOptimist  ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[1].title,
                                                                        href: "/"
                                                                    }),
                                                                    " was approached by Smooth Mover Removals to create a new WordPress website and provide affordable SEO services."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: "The team at SEOptimist designed and developed a new WordPress website for Smooth Mover Removals, with a focus on user experience and search engine optimization. We implemented a clean and modern design, easy navigation, and clear calls-to-action to improve conversion rates."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: "To ensure that the website was optimized for search engines, we conducted a comprehensive SEO audit of the website. We identified areas for improvement, including optimizing meta titles and descriptions, improving site speed, and implementing schema markup."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                width: "100%",
                                                                height: "auto",
                                                                src: "/img/clients/affordable-seo.jpg",
                                                                alt: Portfolio[0].title,
                                                                style: {
                                                                    background: "transparent"
                                                                },
                                                                className: "mb-10 rounded-3 mw-30"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                                children: [
                                                                    Portfolio[1].title,
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                children: [
                                                                    "As part of the ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[5].title,
                                                                        href: "/"
                                                                    }),
                                                                    ", SEOptimist  provided a detailed report to the client, outlining our recommendations for improving the website's search engine rankings. We also provided guidance on how to implement the recommendations themselves, which allowed the client to make the necessary changes at an affordable cost."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: "By implementing our recommendations, Smooth Mover Removals saw a significant improvement in their search engine rankings, which led to an increase in traffic and enquiries. The affordable SEO services we provided allowed the client to improve their online visibility without breaking the bank."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: "At SEOptimist, we understand that not every business has the budget to invest in full SEO services, which is why we offer affordable solutions that can be implemented by the client themselves. Our team of experts can provide a comprehensive SEO audit and make recommendations that are easy to understand and implement, so that you can improve your search engine rankings and increase your online visibility. Contact us today to learn more about our affordable SEO services for London & Brighton."
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                title: "Contact",
                                                                href: "/#contact",
                                                                className: "more hover"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-md-3 ms-auto order-1 pt-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                width: 275,
                                                                height: "auto",
                                                                src: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                                alt: Portfolio[0].title,
                                                                style: {
                                                                    background: "transparent"
                                                                },
                                                                className: "mb-10 rounded-top rounded-3"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                className: "list-unstyled",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                className: "mb-1",
                                                                                children: "Categories"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                children: details.categories
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                className: "mb-1",
                                                                                children: "Client Name"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                children: details.pageName
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__/* .LocalSEO */ .wx, {
                                    initialslide: 0
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                location: "london"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectDetails);


/***/ }),

/***/ 4153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var ProjectDetailsNavigation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "wrapper bg-light"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProjectDetailsNavigation);


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 959:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useIsotope = function() {
    var isotope = useRef();
    var ref = useState("*"), filterKey = ref[0], setFilterKey = ref[1];
    useEffect(function() {
        if (false) {}
        _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var Isotope, grids;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return __webpack_require__.e(/* import() */ 3391).then(__webpack_require__.t.bind(__webpack_require__, 3391, 23));
                    case 2:
                        Isotope = _ctx.sent.default;
                        grids = document.querySelectorAll(".grid");
                        if (grids !== null) {
                            grids.forEach(function(g) {
                                var grid = g.querySelector(".isotope");
                                isotope.current = new Isotope(grid, {
                                    itemSelector: ".item",
                                    layoutMode: "masonry",
                                    masonry: {
                                        columnWidth: grid.offsetWidth / 12
                                    },
                                    percentPosition: true,
                                    transitionDuration: "0.7s"
                                });
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        return function() {
            var ref;
            return (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.destroy();
        };
    }, []);
    useEffect(function() {
        var ref;
        var filtered = filterKey === "*" ? {
            filter: "*"
        } : {
            filter: filterKey
        };
        (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.arrange(filtered);
    }, [
        filterKey
    ]);
    // change filter item
    var handleFilterKeyChange = function(key) {
        return function() {
            return setFilterKey(key);
        };
    };
    return {
        handleFilterKeyChange: handleFilterKeyChange,
        filterKey: filterKey
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useIsotope)));


/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var carouselBreakpoints = {
    0: {
        slidesPerView: 1
    },
    768: {
        slidesPerView: 2
    },
    1200: {
        slidesPerView: 3
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (carouselBreakpoints);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4870,4556,6435,362,9774,2888,179], function() { return __webpack_exec__(5661); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);